
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-e90dd036\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!sass-resources-loader?{\"resources\":[\"/data/www/newcode/platform-admin/src/style/theme.scss\",\"/data/www/newcode/platform-admin/src/style/_mixin.scss\"]}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./vshopuserrecord.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./vshopuserrecord.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-e90dd036\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./vshopuserrecord.vue"),
  /* scopeId */
  "data-v-e90dd036",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/view/vshopuserrecord.vue
// module id = 966
// module chunks = 30